/*
 * Code blocks on the public pages outside the docs (22 October 2026): the same
 * Prism highlighting and copy button as the docs pages. hoist_code_blocks()
 * adds this app, and themes/barkoder/css/code-blocks.min.css, to a page that
 * has a .codeBlock.
 */
import { highlightUnder } from '../docs_public_runtime/highlight.js';
import { initCopyCode } from '../docs_public_runtime/code_copy.js';

initCopyCode('.codeBlock > button');
highlightUnder(document);
